import { Popper, PopperProps as MUI_PopperProps } from "@mui/material";
import React from "react";

export const customPopper = (
  containerRef: React.RefObject<HTMLDivElement>
) => (props: MUI_PopperProps) => {
  return <Popper {...props} container={containerRef?.current} />
};
